/* Lapiaf landing ducha-pp-2-0 - interacciones (galeria, ofertas, acordeones, typewriter, sticky bar) */
(function () {
  var root = document.getElementById('lpf-landing');
  if (!root) return;

  // Galeria: swipe con scroll-snap + thumbs sincronizados
  var track = document.getElementById('galleryMain');
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('#thumbs .thumb'));
  // distancia real entre slides (ancho + gap del carrusel)
  function gStride() {
    if (!track) return 1;
    var s = track.children;
    return s.length > 1 ? (s[1].offsetLeft - s[0].offsetLeft) : track.clientWidth;
  }
  function setActiveThumb(i) {
    thumbs.forEach(function (t, j) { t.classList.toggle('active', j === i); });
    var t = thumbs[i];
    if (t && t.scrollIntoView) t.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
  }
  if (track && thumbs.length) {
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () {
        track.scrollTo({ left: i * gStride(), behavior: 'smooth' });
        setActiveThumb(i);
      });
    });
    var scrollTimer;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function () {
        var i = Math.round(track.scrollLeft / gStride());
        if (i >= 0 && i < thumbs.length) setActiveThumb(i);
      }, 80);
    }, { passive: true });
  }

  // Miniaturas: pistas de "hay mas" (degradado + flecha) segun posicion del scroll
  (function () {
    var wrap = root.querySelector('.thumbs-wrap');
    var strip = document.getElementById('thumbs');
    if (!wrap || !strip) return;
    function updateHints() {
      var max = strip.scrollWidth - strip.clientWidth - 1;
      wrap.classList.toggle('hint-left', strip.scrollLeft > 2);
      wrap.classList.toggle('hint-right', max > 2 && strip.scrollLeft < max);
    }
    strip.addEventListener('scroll', updateHints, { passive: true });
    window.addEventListener('resize', updateHints);
    updateHints();
  })();

  // Zoom: boton de lupa -> popup con carrusel (swipe) y pellizco para acercar
  (function () {
    var gal = root.querySelector('.gallery');
    if (!gal || gal.dataset.zoom !== 'true' || !track) return;
    var zoomBtn = gal.querySelector('.gzoom');
    if (!zoomBtn) return;
    var slides = Array.prototype.slice.call(track.querySelectorAll('.gslide img'));
    if (!slides.length) return;
    var lb = document.createElement('div');
    lb.className = 'lpf-lightbox';
    lb.innerHTML = '<button class="lb-close" type="button" aria-label="Cerrar">&times;</button><div class="lb-track">' +
      slides.map(function (im) { return '<div class="lb-slide"><img src="' + (im.currentSrc || im.src) + '" alt=""></div>'; }).join('') +
      '</div>';
    root.appendChild(lb);
    var lbTrack = lb.querySelector('.lb-track');
    var lbImgs = Array.prototype.slice.call(lb.querySelectorAll('.lb-slide img'));

    var scale = 1, baseDist = 0, curImg = null, ptrs = {};
    function resetZoom() {
      if (curImg) curImg.style.transform = '';
      scale = 1; baseDist = 0; curImg = null;
    }
    function closeLb() { lb.classList.remove('open'); document.body.style.overflow = ''; resetZoom(); }
    function openLb(idx) {
      lb.classList.add('open');
      document.body.style.overflow = 'hidden';
      var i = typeof idx === 'number' ? idx : Math.round(track.scrollLeft / gStride());
      requestAnimationFrame(function () { lbTrack.scrollLeft = i * lbTrack.clientWidth; });
    }
    zoomBtn.addEventListener('click', function () { openLb(); });
    Array.prototype.forEach.call(gal.querySelectorAll('.gcollage .gcol-item'), function (el) {
      el.addEventListener('click', function () { openLb(parseInt(el.dataset.idx, 10) || 0); });
    });
    lb.addEventListener('click', function (e) {
      if (e.target === lb || e.target.classList.contains('lb-close') || e.target.classList.contains('lb-slide')) closeLb();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeLb(); });

    // pellizco (pinch) sobre la imagen visible; el swipe lo maneja el scroll nativo
    lbTrack.addEventListener('scroll', resetZoom, { passive: true });
    lbTrack.addEventListener('touchmove', function (e) { if (e.touches.length > 1) e.preventDefault(); }, { passive: false });
    lbTrack.addEventListener('pointerdown', function (e) { ptrs[e.pointerId] = e; });
    lbTrack.addEventListener('pointermove', function (e) {
      if (!ptrs[e.pointerId]) return;
      ptrs[e.pointerId] = e;
      var ids = Object.keys(ptrs);
      if (ids.length !== 2) return;
      var a = ptrs[ids[0]], b = ptrs[ids[1]];
      var d = Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY);
      if (!baseDist) {
        baseDist = d / scale;
        curImg = lbImgs[Math.round(lbTrack.scrollLeft / lbTrack.clientWidth)];
      }
      scale = Math.min(4, Math.max(1, d / baseDist));
      if (curImg) curImg.style.transform = 'scale(' + scale + ')';
    });
    function drop(e) { delete ptrs[e.pointerId]; if (Object.keys(ptrs).length < 2) baseDist = 0; }
    lbTrack.addEventListener('pointerup', drop);
    lbTrack.addEventListener('pointercancel', drop);
  })();

  // Seleccion de oferta -> sincroniza form real (selling_plan + items extra) y precios visibles
  var offers = root.querySelectorAll('#offers .offer');
  var ctaPrice = document.getElementById('ctaPrice');
  var stickyPrice = document.getElementById('stickyPrice');
  var form = document.getElementById('lpf-product-form');

  function applyOffer(o) {
    offers.forEach(function (x) { x.classList.remove('sel'); });
    o.classList.add('sel');
    var disp = o.dataset.priceDisplay || '';
    if (disp) {
      if (ctaPrice) ctaPrice.textContent = disp;
      if (stickyPrice) stickyPrice.textContent = disp;
    }
    if (form) {
      var sp = form.querySelector('input[name="selling_plan"]');
      if (sp) sp.value = o.dataset.sellingPlan || '';
      form.querySelectorAll('input[data-lpf-extra]').forEach(function (inp) {
        inp.disabled = inp.dataset.lpfExtra !== o.dataset.offerId;
      });
    }
  }
  offers.forEach(function (o) {
    o.addEventListener('click', function () { applyOffer(o); });
  });
  var initial = root.querySelector('#offers .offer.sel') || offers[0];
  if (initial) applyOffer(initial);

  // Widget de oferta: cantidad (1-3) + interruptor de suscripcion -> escribe quantity/selling_plan en el form real
  (function () {
    var box = document.getElementById('lpfOffer');
    if (!box) return;
    var unit = parseInt(box.dataset.unit, 10) || 0;
    var saves = { 1: 0, 2: parseInt(box.dataset.save2, 10) || 0, 3: parseInt(box.dataset.save3, 10) || 0 };
    var subUnit = parseInt(box.dataset.subunit, 10) || 0;
    var plan = box.dataset.plan || '';
    var title = box.querySelector('.js-of-subtitle');
    function money(c) {
      // mismo formato que money_without_trailing_zeros de la tienda: "$ 1,499"
      var n = c / 100;
      return '$\u00a0' + (n % 1 ? n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : n.toLocaleString('en-US'));
    }
    function update() {
      var q = parseInt(box.dataset.qty, 10) || 1;
      var sub = box.dataset.sub === '1' && plan !== '';
      var total = unit * q - (saves[q] || 0);
      box.querySelectorAll('[data-q]').forEach(function (el) { el.classList.toggle('on', parseInt(el.dataset.q, 10) === q); });
      if (title) {
        var t = q === 1 ? (title.dataset.s1 || title.dataset.sn || '') : (title.dataset.sn || '');
        title.textContent = t.replace('{n}', q);
      }
      var cargo = box.querySelector('.js-of-cargo');
      if (cargo) {
        var tpl = q === 1 ? (cargo.dataset.t1 || '{total} por 1 filtro') : (cargo.dataset.tn || '{total} por {n} filtros');
        cargo.textContent = tpl.replace('{total}', money(subUnit * q)).replace('{n}', q);
      }
      var row = box.querySelector('.of-subrow');
      if (row) row.classList.toggle('off', !sub);
      var sw = box.querySelector('.of-switch');
      if (sw) sw.setAttribute('aria-checked', sub ? 'true' : 'false');
      if (ctaPrice) ctaPrice.textContent = q === 1 ? '1 ' + (box.dataset.unit1 || 'Ducha') : q + ' ' + (box.dataset.unitn || 'Duchas');
      if (stickyPrice) stickyPrice.textContent = money(total);
      if (form) {
        var qi = form.querySelector('input[name="quantity"]');
        if (qi) qi.value = q;
        var spi = form.querySelector('input[name="selling_plan"]');
        if (spi) spi.value = '';
      }
      document.querySelectorAll('.js-of-subitem').forEach(function (inp) {
        inp.disabled = !sub;
        if (inp.name === 'items[0][quantity]') inp.value = q;
      });
    }
    box.addEventListener('click', function (e) {
      var b = e.target.closest('[data-q]');
      if (b) {
        var changed = b.dataset.q !== box.dataset.qty;
        box.dataset.qty = b.dataset.q;
        update();
        if (changed) { b.classList.remove('pop'); void b.offsetWidth; b.classList.add('pop'); }
        return;
      }
      if (e.target.closest('.js-of-subtoggle')) { box.dataset.sub = box.dataset.sub === '1' ? '0' : '1'; update(); }
    });
    var fecha = box.querySelector('.js-of-fecha');
    if (fecha) {
      var row = box.querySelector('.of-subrow');
      var days = parseInt(row && row.dataset.days, 10) || 90;
      var dt = new Date();
      dt.setDate(dt.getDate() + days);
      fecha.textContent = dt.toLocaleDateString('es-MX', { day: 'numeric', month: 'short' }).replace('.', '');
    }
    update();
  })();

  // FAQ accordion
  root.querySelectorAll('.faq-q').forEach(function (q) {
    q.addEventListener('click', function () {
      var item = q.parentElement, a = q.nextElementSibling;
      var open = item.classList.contains('open');
      root.querySelectorAll('.faq-item').forEach(function (i) {
        i.classList.remove('open');
        i.querySelector('.faq-a').style.maxHeight = null;
      });
      if (!open) { item.classList.add('open'); a.style.maxHeight = a.scrollHeight + 'px'; }
    });
  });

  // Buy-box accordion (una sola apertura + primero abierto por defecto)
  (function () {
    var items = root.querySelectorAll('.buy-acc .acc-item');
    function closeAll() {
      items.forEach(function (i) { i.classList.remove('open'); i.querySelector('.acc-a').style.maxHeight = null; });
    }
    root.querySelectorAll('.buy-acc .acc-q').forEach(function (q) {
      q.addEventListener('click', function () {
        var item = q.parentElement, a = q.nextElementSibling;
        var isOpen = item.classList.contains('open');
        closeAll();
        if (!isOpen) { item.classList.add('open'); a.style.maxHeight = a.scrollHeight + 'px'; }
      });
    });
    var first = items[0];
    if (first) { first.classList.add('open'); var fa = first.querySelector('.acc-a'); fa.style.maxHeight = fa.scrollHeight + 'px'; }
  })();

  // Efecto maquina de escribir (frases desde los settings del bloque)
  (function () {
    var el = document.getElementById('twText');
    if (!el) return;
    var prefix = el.dataset.prefix || 'Semana ';
    var items = [el.dataset.p1, el.dataset.p2, el.dataset.p3, el.dataset.p4]
      .filter(function (x) { return x && x.trim(); })
      .map(function (x) { return { s: x, pauseBefore: x.indexOf(' ;)') > -1 ? ' ;)' : null }; });
    if (!items.length) return;
    function esc(x) { return x.replace(/&/g, '&amp;').replace(/</g, '&lt;'); }
    var pi = 0, ci = 0, del = false;
    function render(n) {
      var suf = items[pi].s.slice(0, n);
      el.innerHTML = '<span class="tw-wk">' + esc(prefix) + esc(suf.slice(0, 1)) + '</span>' + esc(suf.slice(1));
    }
    function tick() {
      var it = items[pi], len = it.s.length;
      var pa = it.pauseBefore ? it.s.indexOf(it.pauseBefore) : -1;
      if (!del) {
        ci++; render(ci);
        if (ci >= len) { del = true; return setTimeout(tick, 1700); }
        setTimeout(tick, ci === pa ? 780 : 28 + Math.random() * 20);
      } else {
        ci--; render(ci);
        if (ci <= 0) { del = false; pi = (pi + 1) % items.length; return setTimeout(tick, 260); }
        setTimeout(tick, 15);
      }
    }
    render(0);
    tick();
  })();

  // Auto-ajuste del titular: maximiza el tamano hasta el limite exacto del ancho
  // del dispositivo SIN alterar los saltos de linea (busqueda binaria sobre el
  // numero de lineas). Corre tras cargar PP Eiko (las metricas cambian con swap).
  (function () {
    var box = root.querySelector('.lpf-headline[data-lpf-fit]');
    if (!box) return;
    var h1 = box.querySelector('h1');
    var sol = box.querySelector('.solution');
    if (!h1) return;
    function linesOf(el) {
      var lh = parseFloat(getComputedStyle(el).lineHeight) || 1;
      return Math.max(1, Math.round(el.getBoundingClientRect().height / lh));
    }
    function maxFactor(el) {
      el.style.fontSize = '';
      var base = parseFloat(getComputedStyle(el).fontSize);
      var baseLines = linesOf(el);
      var lo = base, hi = base * 2.6;
      for (var i = 0; i < 12; i++) {
        var mid = (lo + hi) / 2;
        el.style.fontSize = mid + 'px';
        if (linesOf(el) > baseLines) hi = mid; else lo = mid;
      }
      el.style.fontSize = '';
      return lo / base;
    }
    function fit() {
      var k = Math.min(maxFactor(h1), sol ? maxFactor(sol) : 99) * 0.99;
      if (k < 1) k = 1;
      var b1 = parseFloat(getComputedStyle(h1).fontSize);
      h1.style.fontSize = (b1 * k) + 'px';
      if (sol) {
        var b2 = parseFloat(getComputedStyle(sol).fontSize);
        sol.style.fontSize = (b2 * k) + 'px';
      }
    }
    var t;
    function fitSoon() { clearTimeout(t); t = setTimeout(fit, 120); }
    fit();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
    window.addEventListener('resize', fitSoon);
  })();

  // Sticky mobile buy bar on scroll
  var bar = document.getElementById('stickyBar');
  var hero = document.getElementById('comprar');
  if (bar && hero) {
    window.addEventListener('scroll', function () {
      bar.classList.toggle('show', hero.getBoundingClientRect().bottom < 0);
    });
  }
})();


// ===== 2-1: oferta única — con/sin suscripción habilita la línea del filtro incluido =====
(function () {
  var box = document.getElementById('lpfOs');
  if (!box) return;
  var plan = box.dataset.plan || '';
  function update() {
    var sub = box.dataset.sub === '1' && plan !== '';
    box.querySelectorAll('.js-os-opt').forEach(function (c) {
      c.classList.toggle('on', (c.dataset.opt === 'auto') === sub);
    });
    document.querySelectorAll('.js-os-subitem').forEach(function (inp) { inp.disabled = !sub; });
    var code = box.dataset.code || '';
    if (code) {
      // aplica el codigo del descuento extra con suscripcion; sin suscripcion lo pisa con uno inexistente (el checkout lo ignora)
      try { fetch('/discount/' + encodeURIComponent(sub ? code : 'LAPIAF-NA'), { credentials: 'same-origin' }); } catch (e) {}
    }
    var form = document.getElementById('lpf-product-form');
    if (form) {
      var spi = form.querySelector('input[name="selling_plan"]');
      if (spi) spi.value = '';
      var qi = form.querySelector('input[name="quantity"]');
      if (qi) qi.value = 1;
    }
    // sincroniza sticky bar y CTA con el precio de la tarjeta seleccionada
    var priceEl = box.querySelector('.js-os-opt' + (sub ? '[data-opt="auto"]' : '[data-opt="once"]') + ' .os-line b');
    if (priceEl) {
      var precio = priceEl.textContent.trim();
      var sp = document.getElementById('stickyPrice');
      if (sp) sp.textContent = precio;
      var cp = document.getElementById('ctaPrice');
      if (cp) cp.textContent = precio;
    }
  }
  box.addEventListener('click', function (e) {
    var c = e.target.closest('.js-os-opt');
    if (!c) return;
    box.dataset.sub = c.dataset.opt === 'auto' ? '1' : '0';
    update();
  });
  update();
})();

// ===== 2-1: franja del filtro — clic lleva la galería a la foto indicada =====
(function () {
  var strip = document.querySelector('.lpf-fstrip[data-slide]');
  if (!strip) return;
  function go() {
    var i = parseInt(strip.dataset.slide, 10) || 0;
    var track = document.getElementById('galleryMain');
    var g = track || document.querySelector('#lpf-landing .gallery');
    function slide() {
      if (!track || !track.children.length) return;
      var s = track.children;
      var k = Math.min(i, s.length - 1);
      var stride = s.length > 1 ? (s[1].offsetLeft - s[0].offsetLeft) : track.clientWidth;
      track.scrollTo({ left: k * stride, behavior: 'smooth' });
    }
    // dos smooth simultaneos se cancelan entre si: solo si hay que subir a la
    // galeria se difiere el recorrido horizontal; si ya esta a la vista, directo
    var needsV = false;
    if (g) {
      var r = g.getBoundingClientRect();
      needsV = r.top < 0 || r.bottom > (window.innerHeight || document.documentElement.clientHeight);
    }
    if (needsV) {
      g.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      setTimeout(slide, 350);
    } else {
      slide();
    }
  }
  strip.addEventListener('click', go);
  strip.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); go(); } });
})();

// ===== 2-1: galeria desktop "G10" — cluster esquina, dock, bordes geometricos =====
(function () {
  if (!window.matchMedia || !window.matchMedia('(min-width:1024px)').matches) return;
  var root = document.getElementById('lpf-landing');
  if (!root) return;
  var gal = root.querySelector('.gallery');
  var track = document.getElementById('galleryMain');
  var thumbsEl = root.querySelector('#thumbs');
  if (!gal || !track || !thumbsEl || track.children.length < 2) return;
  var thumbs = thumbsEl.querySelectorAll('.thumb');
  gal.classList.add('gd-mode');

  // escenario con posicion propia para anclar el cluster (el track conserva sus listeners)
  var stage = document.createElement('div');
  stage.className = 'gd-stage';
  track.parentNode.insertBefore(stage, track);
  stage.appendChild(track);

  var n = track.children.length;
  var ctl = document.createElement('div');
  ctl.className = 'gd-ctl';
  ctl.innerHTML = '<button type="button" class="gd-prev" aria-label="Foto anterior">‹</button><span class="gd-cnt"></span><button type="button" class="gd-next" aria-label="Foto siguiente">›</button>';
  stage.appendChild(ctl);
  var bPrev = ctl.querySelector('.gd-prev'), bNext = ctl.querySelector('.gd-next'), cnt = ctl.querySelector('.gd-cnt');

  function stride() {
    var s = track.children;
    return s.length > 1 ? (s[1].offsetLeft - s[0].offsetLeft) : track.clientWidth;
  }
  function idx() { return Math.max(0, Math.min(n - 1, Math.round(track.scrollLeft / stride()))); }
  function update() {
    var i = idx();
    cnt.textContent = (i + 1) + ' / ' + n;
    bPrev.disabled = (i <= 0);
    bNext.disabled = (i >= n - 1);
  }
  bPrev.addEventListener('click', function () { var i = idx(); if (i > 0) track.scrollTo({ left: (i - 1) * stride(), behavior: 'smooth' }); });
  bNext.addEventListener('click', function () { var i = idx(); if (i < n - 1) track.scrollTo({ left: (i + 1) * stride(), behavior: 'smooth' }); });
  track.addEventListener('scroll', update, { passive: true });
  update();

  // bordes "hay mas": verdad geometrica por frame (misma regla espejo en ambos lados)
  var wrap = root.querySelector('.thumbs-wrap');
  if (wrap && thumbs.length) {
    (function watch() {
      var r = thumbsEl.getBoundingClientRect();
      var f = thumbs[0].getBoundingClientRect();
      var l = thumbs[thumbs.length - 1].getBoundingClientRect();
      wrap.classList.toggle('hint-left', f.left < r.left - 1);
      wrap.classList.toggle('hint-right', l.right > r.right + 1);
      requestAnimationFrame(watch);
    })();
    var hl = wrap.querySelector('.thumbs-hint-left');
    var hr = wrap.querySelector('.thumbs-hint-right');
    if (hl) hl.addEventListener('click', function () { thumbsEl.scrollBy({ left: -thumbsEl.clientWidth * 0.6, behavior: 'smooth' }); });
    if (hr) hr.addEventListener('click', function () { thumbsEl.scrollBy({ left: thumbsEl.clientWidth * 0.6, behavior: 'smooth' }); });
  }
})();
